var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "agg-sections" },
    [
      _c("div", { staticClass: "reporting-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("i", { staticClass: "material-icons section-icon" }, [
            _vm._v("dashboard"),
          ]),
          _c("h2", [_vm._v(_vm._s(_vm.$t("dash.reporting.overview")))]),
          _c("span", { staticClass: "agg-badge" }, [
            _vm._v(_vm._s(_vm.networksLabel)),
          ]),
          _vm.prevLoading
            ? _c("span", { staticClass: "prev-loading-badge" }, [
                _c("span", { staticClass: "prev-loading-dot" }),
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.prev_loading")) + "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "metric-row" },
          [
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.page_fans,
                "previous-value": _vm.prev.page_fans,
                label: _vm.$t("dash.reporting.followers"),
                icon: "group",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.nb_posts,
                "previous-value": _vm.prev.nb_posts,
                label: _vm.$t("dash.reporting.publications"),
                icon: "edit",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.totalImpressions,
                "previous-value": _vm.prev.totalImpressions,
                label: _vm.$t("dash.reporting.impression"),
                icon: "visibility",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.totalEngagement,
                "previous-value": _vm.prev.totalEngagement,
                label: _vm.$t("dash.reporting.interactions"),
                icon: "fa-solid fa-hand-point-up",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.totalReactions,
                "previous-value": _vm.prev.totalReactions,
                label: _vm.$t("dash.reporting.reaction"),
                icon: "thumb_up",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.totalComments,
                "previous-value": _vm.prev.totalComments,
                label: _vm.$t("dash.reporting.comment"),
                icon: "chat_bubble",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.totals.totalShares,
                "previous-value": _vm.prev.totalShares,
                label: _vm.$t("dash.reporting.share"),
                icon: "share",
              },
            }),
            _vm.totals.totalClicks > 0
              ? _c("MetricCard", {
                  attrs: {
                    value: _vm.totals.totalClicks,
                    "previous-value": _vm.prev.totalClicks,
                    label: _vm.$t("dash.reporting.clic"),
                    icon: "touch_app",
                  },
                })
              : _vm._e(),
            _vm.totals.totalImpressions > 0
              ? _c("MetricCard", {
                  attrs: {
                    value: _vm.globalEngagementRate,
                    "previous-value": _vm.prevEngagementRate,
                    label: _vm.$t("dash.reporting.engagement_rate"),
                    icon: "show_chart",
                    format: "percent",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.fansSection.show
        ? _c(
            "div",
            { staticClass: "reporting-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("i", { staticClass: "material-icons section-icon" }, [
                  _vm._v("group"),
                ]),
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.reporting.section.audience.title"))
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "metric-row",
                  staticStyle: { "margin-bottom": "16px" },
                },
                [
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.page_fans,
                      "previous-value": _vm.prev.page_fans,
                      label: _vm.$t("dash.reporting.followers"),
                      icon: "group",
                    },
                  }),
                  _vm.totals.sumFanAdds > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.sumFanAdds,
                          label: _vm.$t("dash.reporting.new_followers"),
                          icon: "person_add",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.sumFanRemoves > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.sumFanRemoves,
                          label: _vm.$t("dash.reporting.nb_fans.lost_fans"),
                          icon: "remove_circle",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.organicFollowerGain > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.organicFollowerGain,
                          label: _vm.$t("dash.reporting.organicFollowerGain"),
                          icon: "person_add",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.paidFollowerGain > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.paidFollowerGain,
                          label: _vm.$t("dash.reporting.paidFollowerGain"),
                          icon: "paid",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.fansSection.chart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.followers"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-fans",
                        data: _vm.fansSection.chart.data,
                        labels: _vm.fansSection.chart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.impressionsSection.show
        ? _c(
            "div",
            { staticClass: "reporting-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("i", { staticClass: "material-icons section-icon" }, [
                  _vm._v("visibility"),
                ]),
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.reporting.section.impressions.title"))
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "metric-row",
                  staticStyle: { "margin-bottom": "16px" },
                },
                [
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.totalImpressions,
                      "previous-value": _vm.prev.totalImpressions,
                      label: _vm.$t("dash.reporting.impression"),
                      icon: "visibility",
                    },
                  }),
                  _vm.totals.totalReach > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalReach,
                          label: _vm.$t("dash.label.fb.impressions_reach"),
                          icon: "people",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalOrganic > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalOrganic,
                          label: _vm.$t("dash.label.fb.impressions_organic"),
                          icon: "eco",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalPaid > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalPaid,
                          label: _vm.$t("dash.label.fb.impressions_paid"),
                          icon: "monetization_on",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalViral > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalViral,
                          label: _vm.$t("dash.label.fb.impressions_viral"),
                          icon: "share",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalUniqueImpressions > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalUniqueImpressions,
                          label: _vm.$t("dash.reporting.unique_impression"),
                          icon: "visibility_off",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalPageViews > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalPageViews,
                          label: _vm.$t("dash.reporting.page_views"),
                          icon: "web",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.impressionsSection.chart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.impression"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-impressions",
                        data: _vm.impressionsSection.chart.data,
                        labels: _vm.impressionsSection.chart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.engagementSection.show
        ? _c(
            "div",
            { staticClass: "reporting-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("i", { staticClass: "material-icons section-icon" }, [
                  _vm._v("thumb_up"),
                ]),
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.reporting.section.engagements.title"))
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "metric-row",
                  staticStyle: { "margin-bottom": "16px" },
                },
                [
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.totalEngagement,
                      "previous-value": _vm.prev.totalEngagement,
                      label: _vm.$t("dash.reporting.interactions"),
                      icon: "fa-solid fa-hand-point-up",
                    },
                  }),
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.totalReactions,
                      "previous-value": _vm.prev.totalReactions,
                      label: _vm.$t("dash.reporting.reaction"),
                      icon: "thumb_up",
                    },
                  }),
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.totalComments,
                      "previous-value": _vm.prev.totalComments,
                      label: _vm.$t("dash.reporting.comment"),
                      icon: "chat_bubble",
                    },
                  }),
                  _c("MetricCard", {
                    attrs: {
                      value: _vm.totals.totalShares,
                      "previous-value": _vm.prev.totalShares,
                      label: _vm.$t("dash.reporting.share"),
                      icon: "share",
                    },
                  }),
                  _vm.totals.totalClicks > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.totals.totalClicks,
                          "previous-value": _vm.prev.totalClicks,
                          label: _vm.$t("dash.reporting.clic"),
                          icon: "touch_app",
                        },
                      })
                    : _vm._e(),
                  _vm.totals.totalImpressions > 0
                    ? _c("MetricCard", {
                        attrs: {
                          value: _vm.globalEngagementRate,
                          label: _vm.$t("dash.reporting.engagement_rate"),
                          icon: "show_chart",
                          format: "percent",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.engagementSection.chart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.interactions"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-engagement",
                        data: _vm.engagementSection.chart.data,
                        labels: _vm.engagementSection.chart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.hasMultipleNetworks
        ? _c(
            "div",
            { staticClass: "reporting-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("i", { staticClass: "material-icons section-icon" }, [
                  _vm._v("compare_arrows"),
                ]),
                _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.reporting.section.comparison.by_network")
                    )
                  ),
                ]),
              ]),
              _vm.networkImpressionsChart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.impression"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-net-impressions",
                        data: _vm.networkImpressionsChart.data,
                        labels: _vm.networkImpressionsChart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.networkEngagementChart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.interactions"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-net-engagement",
                        data: _vm.networkEngagementChart.data,
                        labels: _vm.networkEngagementChart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.networkFansChart.data.length
                ? [
                    _c("div", { staticClass: "graph-title" }, [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.followers"))),
                    ]),
                    _c("Graph", {
                      attrs: {
                        id: "agg-net-fans",
                        data: _vm.networkFansChart.data,
                        labels: _vm.networkFansChart.labels,
                        height: "220px",
                        width: "100%",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.allPostsForTop.length
        ? _c("div", { staticClass: "reporting-section" }, [
            _c("div", { staticClass: "section-header" }, [
              _c("i", { staticClass: "material-icons section-icon" }, [
                _vm._v("star"),
              ]),
              _c("h2", [_vm._v("Top 20 posts")]),
              _c("span", { staticClass: "agg-badge" }, [
                _vm._v(
                  _vm._s(_vm.top20Posts.length) +
                    " / " +
                    _vm._s(_vm.allPostsForTop.length) +
                    " posts"
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "top20-table" },
              [
                _c(
                  "div",
                  {
                    staticClass: "top20-table__head",
                    style: { gridTemplateColumns: _vm.top20Grid },
                  },
                  [
                    _c("span", { staticClass: "t20h" }, [_vm._v("#")]),
                    _c("span", { staticClass: "t20h" }, [_vm._v("Page")]),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort",
                        class: { "t20h--active": _vm.sortKey === "date" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("date")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Date"),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("date")))]
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "t20h" }, [_vm._v("Type")]),
                    _c("span", { staticClass: "t20h" }, [
                      _vm._v("Publication"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: {
                          "t20h--active": _vm.sortKey === "impressions",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("impressions")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Imp."),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("impressions")))]
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: { "t20h--active": _vm.sortKey === "reactions" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("reactions")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Réact."),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("reactions")))]
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: { "t20h--active": _vm.sortKey === "comments" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("comments")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Comm."),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("comments")))]
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: { "t20h--active": _vm.sortKey === "shares" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("shares")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Part."),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("shares")))]
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: { "t20h--active": _vm.sortKey === "engagement" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("engagement")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Eng."),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("engagement")))]
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "t20h t20h--sort t20h--right",
                        class: { "t20h--active": _vm.sortKey === "rate" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort("rate")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Taux%"),
                        _c(
                          "i",
                          { staticClass: "material-icons t20-sort-icon" },
                          [_vm._v(_vm._s(_vm.sortIcon("rate")))]
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "t20h" }),
                  ]
                ),
                _vm._l(_vm.top20Posts, function (post, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "top20-table__row",
                      style: { gridTemplateColumns: _vm.top20Grid },
                    },
                    [
                      _c("span", { staticClass: "t20-rank" }, [
                        _vm._v("#" + _vm._s(i + 1)),
                      ]),
                      _c("div", { staticClass: "t20-page" }, [
                        _c("div", { staticClass: "t20-av-wrap" }, [
                          post._page.avatar
                            ? _c("img", {
                                staticClass: "t20-av",
                                attrs: { src: post._page.avatar, alt: "" },
                              })
                            : _c("span", { staticClass: "t20-av-fallback" }, [
                                _vm._v(
                                  _vm._s(
                                    (post._page.name || "?")[0].toUpperCase()
                                  )
                                ),
                              ]),
                          _vm.networkIcon(post._page.network)
                            ? _c("img", {
                                staticClass: "t20-net-badge",
                                attrs: {
                                  src: _vm.networkIcon(post._page.network),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("span", { staticClass: "t20-page-name" }, [
                          _vm._v(_vm._s(post._page.name)),
                        ]),
                      ]),
                      _c("span", { staticClass: "t20-date" }, [
                        _vm._v(_vm._s(_vm.fmtDate(post.created_time))),
                      ]),
                      post.type || post.media_type
                        ? _c(
                            "span",
                            {
                              staticClass: "t20-type-badge",
                              class: _vm.typeBadgeClass(
                                post.type || post.media_type
                              ),
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.typeLabel(post.type || post.media_type)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c("span"),
                      _c("div", { staticClass: "t20-pub" }, [
                        _c("div", { staticClass: "t20-thumb" }, [
                          _vm.postImageUrl(post)
                            ? _c("img", {
                                staticClass: "t20-thumb-img",
                                attrs: { src: _vm.postImageUrl(post), alt: "" },
                              })
                            : _c(
                                "i",
                                { staticClass: "material-icons t20-thumb-ph" },
                                [_vm._v("image")]
                              ),
                        ]),
                        _c("span", { staticClass: "t20-msg" }, [
                          _vm._v(
                            _vm._s(
                              _vm.truncate(
                                post.message ||
                                  post.video_description ||
                                  post.content ||
                                  "",
                                70
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: {
                            "t20-num--active": _vm.sortKey === "impressions",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.fmtNum(
                                post.post_impressions || post.view_count || 0
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: {
                            "t20-num--active": _vm.sortKey === "reactions",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.fmtNum(
                                post.post_reactions_sum || post.like_count || 0
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: {
                            "t20-num--active": _vm.sortKey === "comments",
                          },
                        },
                        [_vm._v(_vm._s(_vm.fmtNum(post.comments_count || 0)))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: {
                            "t20-num--active": _vm.sortKey === "shares",
                          },
                        },
                        [_vm._v(_vm._s(_vm.fmtNum(post.shares_count || 0)))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: {
                            "t20-num--active": _vm.sortKey === "engagement",
                          },
                        },
                        [_vm._v(_vm._s(_vm.fmtNum(_vm.postEngTotal(post))))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "t20-num",
                          class: { "t20-num--active": _vm.sortKey === "rate" },
                        },
                        [_vm._v(_vm._s(_vm.postEngRate(post)))]
                      ),
                      post.permalink_url
                        ? _c(
                            "a",
                            {
                              staticClass: "t20-link",
                              attrs: {
                                href: post.permalink_url,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("open_in_new"),
                              ]),
                            ]
                          )
                        : _c("span"),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.aggregatedDemographics
        ? _c("ReportingDemographics", {
            attrs: { stats: _vm.aggregatedDemographics, page: null },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }